import { render, staticRenderFns } from "./businessInfo2.vue?vue&type=template&id=5bc68758"
import script from "./businessInfo2.vue?vue&type=script&lang=js"
export * from "./businessInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports